<template>
  <div>
    <van-nav-bar
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="form-div">
      <van-field v-model="telephone" label="当前手机号" readonly input-align="right"/>
      <div class="label-div">用户编号<span class="required-span">*</span></div>
      <van-field v-model="userNumber" placeholder="请输入" maxlength="11"/>
      <div class="label-div">验证码<span class="required-span">*</span></div>
      <van-field
        v-model="sms"
        center
        maxlength="6"
        clearable
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button class="verification-code-button" :disabled="isSmsSend" @click="verify()">
            {{sendBtnText}}
          </van-button>
        </template>
      </van-field>
      <div class="unknown-number-div" @click="toFindUserNumber()">不知道用户编号？</div>
    </div>
    <div class="button-div">
      <van-button color="#CE0022" class="login-button button-shadow" @click="toVerifyAddress()">核实地址</van-button>
    </div>
  </div>
</template>

<script>
import { passwordEncryption } from '../../utils/jsencrypt'
import { getVerificationCode, checkUserGas } from '../../api/accountNumberManagement'

export default {
  name: 'AddAccountNumber',
  data () {
    return {
      telephone: '', // 当前手机号
      userNumber: '', // 用户编号
      sms: '', // 验证码
      isSmsSend: false, // 是否已经发送了验证码
      timer: null,
      sendBtnText: '获取', // 获取验证码按钮文本
      counter: 60 // 倒计时秒数
    }
  },
  mounted () {
    this.telephone = JSON.parse(window.localStorage.userInfo).mobile
  },
  methods: {
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    },

    // 核实地址
    toVerifyAddress () {
      const that = this
      const id = that.telephone
      const verify = that.sms
      const regPhone = new RegExp('[0-9]{11}')
      if (!id) {
        that.$toast('请输入手机号')
      } else if (!regPhone.test(id)) {
        that.$toast('您输入的是一个无效的手机号')
      } else if (!that.userNumber) {
        that.$toast('请输入用户编号')
      } else if (!verify) {
        that.$toast('请输入验证码')
      } else if (that.userNumber.length > 11) {
        that.$toast('用户编号格式不正确')
      } else {
        const params = {
          userCode: that.userNumber,
          code: verify
        }
        checkUserGas(params).then(res => {
          if (res.data.success) {
            this.$router.push({
              name: 'VerifyAddress',
              params: {
                data: res.data.rows[0].address,
                number: that.userNumber,
                meterType: res.data.rows[0].meterType,
                isLock: res.data.rows[0].isLock
              }
            })
          } else {
            that.$toast.fail(res.data.message)
          }
        }).catch(() => {
          that.$toast.fail('校验燃气户号失败')
        })
      }
    },

    // 查找用户编号
    toFindUserNumber () {
      this.$router.push('/findUserNumber')
    },

    // 获取验证码
    verify () {
      const that = this
      if (that.telephone.length === 11) {
        const regPhone = new RegExp('[0-9]{11}')
        if (!regPhone.test(that.telephone)) {
          that.$toast.fail('您输入的是一个无效的手机号')
        } else {
          const encodeId = passwordEncryption(that.telephone)
          const params = {
            mobile: encodeURI(encodeId),
            type: 'bindUserGas'
          }
          getVerificationCode(params).then(res => {
            if (res.data.success) {
            } else {
              that.$toast.fail(res.message)
            }
          }).catch(() => {
            that.$toast.fail('获取验证码失败')
          })
          // 将按钮禁用，防止再次点击
          that.isSmsSend = true
          // 开始倒计时，60s之后才能再次点击
          that.countDown()
        }
      } else {
        that.$toast.fail('请输入11位数字用户编号')
      }
    },

    // 倒计时
    countDown () {
      // 将setInterval()方法赋值给前面定义的timer计时器对象，等用clearInterval()方法时方便清空这个计时器对象
      this.timer = setInterval(() => {
        // 替换文本，用es6里面的``这个来创建字符串模板，让秒实时改变
        this.sendBtnText = `${this.counter}s`
        this.counter--
        if (this.counter < 0) {
          // 当计时小于零时，取消该计时器
          clearInterval(this.timer)
          this.reset()
        }
      }, 1000)
    },

    // 重置倒计时
    reset () {
      // 重置按钮可用
      this.isSmsSend = false
      // 重置文本内容
      this.sendBtnText = '获取'
      if (this.timer) {
        // 存在计时器对象，则清除
        clearInterval(this.timer)
        // 重置秒数，防止下次混乱
        this.counter = 60
        // 计时器对象重置为空
        this.timer = null
      }
    }
  }
}
</script>

<style scoped>
  .van-cell {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    padding: 12px 0;
    border-bottom: 1px solid rgba(16, 12, 13, 0.0784313725490196);
  }

  /deep/ .van-field__label {
    color: #62667A;
  }

  /deep/ .van-field__control {
    color: #27282E;
  }

  .label-div {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #27282E;
    text-align: left;
    margin-top: 15px;
  }

  .form-div {
    padding: 0 4%;
  }

  .required-span {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FF7825;
    margin-left: 1px;
  }

  .verification-code-button {
    width: 62px;
    height: 27px;
    border: 1px solid #C7001F;
    border-radius: 4px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #CE0022;
  }

  .unknown-number-div {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #CE0022;
    text-align: left;
    margin-top: 15px;
  }

  .login-button {
    width: 100%;
    height: 50px;
    border-radius: 8px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 12px;
  }

  .button-shadow {
    box-shadow: 0px 6px 12px rgba(206, 0, 34, 0.3);
  }

  .button-div {
    width: 92%;
    margin-left: 4%;
    margin-top: 70%;
  }
</style>
